import {
  IgCoreTextColors,
  IgGrayPrimitives,
} from "@intelligems/ig-design-tokens/constants";

export const LineGroupColors = [
  IgCoreTextColors.primary,
  IgCoreTextColors.secondary,
  IgCoreTextColors.tonal.error,
  IgCoreTextColors.tonal.warning,
  "purple",
  "black",
];

export const TimeSeriesColors = [
  "#2962FF",
  "#f28e2b",
  "#e15759",
  "#76b7b2",
  "#59a14f",
  "#edc948",
  "#b07aa1",
  "#ff9da7",
  "#9c755f",
  "#bab0ac",
];

// One [highlighted, faded] pair per stacked segment: highlighted = the compared
// variation's cell, faded = the others.
export const StackedBarImpactColors = [
  ["#172AB6", "#2962FF"],
  ["#8a90db", "#96adff"],
  ["#4880FF", "#88A6FF"],
];

export const StackedBarColors = [
  "#2962FF",
  "#0013bc",
  "#e15759",
  "#76b7b2",
  "#59a14f",
  "#edc948",
  "#b07aa1",
  "#ff9da7",
  "#9c755f",
  "#bab0ac",
];

export const NewHorizStackedBarColors = {
  productGroups: [
    "#FFD4D4",
    "#FF858D",
    "#FE7F2D",
    "#FCCA46",
    "#57A773",
    "#157145",
    "#9D69A3",
    "#9BD1E5",
    "#5171A5",
    "#2962FF",
  ],
  base: [
    "#CCD6FF",
    "#88A6FF",
    "#4880FF",
    "#2962FF",
    "#0034B4",
    "#001469",
    "#000e4a",
  ],
  gray: [IgGrayPrimitives[800], IgGrayPrimitives["A400"]],
};

export const LiftColors = {
  up: "#E51C00",
  down: "#136F45",
  neutral: "#666",
  noChange: "#000000DE",
};
